import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import { DEVICE } from '@/shahrzad-assets/shared-constants/breakPoints'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize } from '@/shahrzad-assets/shared-constants/fonts'
import { Carousel } from 'antd'
import React from 'react'
import styled from 'styled-components'

const CustomLoginCarousel = () => {
  return (
    <CarouselContainer>
      <CustomCarousel draggable dots={false} className='onboarding-slider'>
        <CarouselItem>
          <img src={icons.HOME_TICKET} />
          <TextContainer>
            <RedText>
              {'عدم نیاز به کارت فیزیکی برای سفر با حمل و نقل عمومی'}
            </RedText>
            <h3>{'کارت بلیت دیجیتال'}</h3>
            <p>
              {
                'شما می توانید از گوشی هوشمند خود به عنوان کارت بلیت برای مترو استفاده کنید. همچنین با اتصال کارت فیزیکی به کیف پول نیازی به شارژ جداگانه کارت فیزیکی نیست.'
              }
            </p>
          </TextContainer>
        </CarouselItem>
        <CarouselItem>
          <img src={icons.HOME_TAXI} />
          <TextContainer>
            <RedText>{'عدم نیاز به پول نقد برای پرداخت کرایه تاکسی'}</RedText>
            <h3>{'پرداخت کرایه تاکسی'}</h3>
            <p>
              {
                'شما می توانید به راحتی و بدون نیاز به حمل پول نقد، کرایه تاکسی خود را با اسکن کد QR تاکسی به صورت آنلاین پرداخت کنید.'
              }
            </p>
          </TextContainer>
        </CarouselItem>
        <CarouselItem>
          <img src={icons.HOME_WALLET} />
          <TextContainer>
            <RedText>{'یک کیف پول برای همه ی خدمات شهری'}</RedText>
            <h3>{'کیف پول شهروندی'}</h3>
            <p>
              {
                'شما می توانید با استفاده از کیف پول شهروندی از همه خدمات شهری به صورت آنلاین و بدون نیاز به حمل پول نقد با تخفیف های ویژه استفاده کنید.'
              }
            </p>
          </TextContainer>
        </CarouselItem>
        <CarouselItem>
          <img src={icons.HOME_MY_TEHRAN} />
          <TextContainer>
            <RedText>{'دیگر نیازی به ثبت نام نیست'}</RedText>
            <h3>{'سامانه ورود یکپارچه'}</h3>
            <p>
              {
                'در صورتی که قبلا در تهران من ثبت‌ نام کردید، می‌توانید با استفاده از نام کاربری یا شماره موبایل ثبت‌ نام شده، از خدمات شهرزاد استفاده کنید.'
              }
            </p>
          </TextContainer>
        </CarouselItem>
      </CustomCarousel>
    </CarouselContainer>
  )
}

export default CustomLoginCarousel
const CarouselContainer = styled.div`
  flex-grow: 1;
  background: ${colors.primaryBrandBg2};

`
const CustomCarousel = styled(Carousel)`
  width: 100%;
  overflow-y: auto;
  min-height: 100vh;
  padding: ${dimens.SPACING_XL};
  /* height: 100%; */
  display: flex !important;
  align-items: center;
  img {
  }
  div {
    direction: ltr !important;
  }
`

const CarouselItem = styled.div`
  img {
    margin: auto;
    @media ${DEVICE.laptop} {
      max-height: 100vh;
    }
    @media ${DEVICE.mobile} {
      width: 80%;
    }
  }
`

const TextContainer = styled.div`
  text-align: center;
  line-height: ${dimens.LINE_HEIGHT_MEDIUM};
  padding: 0 ${dimens.SPACING_M};
  margin-top: ${dimens.SPACING_S};
  /* border-radius: ${dimens.BORDER_RADIUS_8} ${dimens.BORDER_RADIUS_8} 0 0; */
  h3 {
    font-size: ${fontSize.MEDIUM};
    margin: ${dimens.SPACING_S} 0;
  }
  p {
    font-size: ${fontSize.NORMAL};
  }
`

const RedText = styled.span`
  font-size: ${fontSize.SMALL};
  /* color: ${colors.RED}; */
`
